@if (isExpansionGroup) {
  <mat-expansion-panel [expanded]="isExpanded">
    <mat-expansion-panel-header>
      <h2 class="header expansion-panel-header">{{ group.TextId | translate }}</h2>
    </mat-expansion-panel-header>
    <ng-container [ngTemplateOutlet]="propertyForm"></ng-container>
  </mat-expansion-panel>
} @else {
  <div class="cf-flex-column cf-flex-row-lg cf-flex-row-xl">
    <div class="flex-header-container">
      <h2 class="header">{{ group.TextId | translate }}</h2>
    </div>
    <ng-container [ngTemplateOutlet]="propertyForm"></ng-container>
  </div>
}
<ng-template #propertyForm
  ><div class="property-parent">
    @for (property of group.Properties | callback: filterProperties; track property.Key) {
      <div [ngClass]="{ longProperty: isLong(property) }">
        @if (property.ValueType.IsText && !property.Items.length) {
          <app-entity-text-property [property]="property" [formGroup]="formGroup" (propertyChange)="onPropertyChange($event)">
          </app-entity-text-property>
        }

        @if (property.ValueType.IsNumeric && !property.Items.length) {
          <app-entity-number-property [property]="property" [formGroup]="formGroup" (propertyChange)="onPropertyChange($event)">
          </app-entity-number-property>
        }

        @if (property.ValueType.IsBoolean) {
          <app-entity-boolean-property [property]="property" [formGroup]="formGroup" (propertyChange)="onPropertyChange($event)">
          </app-entity-boolean-property>
        }

        @if (property.Items.length > 0) {
          <app-entity-list-property
            [property]="property"
            [formGroup]="formGroup"
            (propertyChange)="onPropertyChange($event)"
            [isRadioButton]="isRadioButton(property)"
          >
          </app-entity-list-property>
        }
      </div>
    }</div
></ng-template>
